import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "account-status" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = {
  class: "alert alert-info mb-0",
  role: "alert"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_7 = { class: "text-danger" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "d-md-flex" }
const _hoisted_10 = ["disabled"]

import { ref, computed, watch } from "vue";
    import { useStore } from "vuex";
    import { app } from "@/guiide/ts/app";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AccountInfo',
  setup(__props) {

    const store = useStore();

    let resetTimeoutId = null;

    const shouldHighlightRetirementStatus = ref(false);
    const resetClicked = ref(false);
    const resetDisabled = ref(false);
    const resetErrorText = ref('');

    const buttonText = computed(() => resetClicked.value ? "Confirm reset" : "Reset");

    const buttonAction = computed(() => resetClicked.value ? "btn-danger" : "btn-warning");

    const isRetired = computed(() => store.state.retiree?.alreadyDrawingPension ?? false);

    const isInRetirementText = computed(() => isRetired.value ? 'in-retirement' : 'pre-retirement');

    watch(
        () => isRetired.value,
        (newValue: boolean, oldValue: boolean) => {
            if (oldValue && !newValue) {
                shouldHighlightRetirementStatus.value = true;

                setTimeout(() => {
                    shouldHighlightRetirementStatus.value = false;
                }, 2000);
            }
        }
    )

    async function handleReset() {
        if (!resetClicked.value) {
            resetClicked.value = true;
            resetTimeoutId = setTimeout(() => {
                resetClicked.value = false;
                resetTimeoutId = null;
            }, 5000);
        } else {
            if (resetTimeoutId) {
                clearTimeout(resetTimeoutId);
                resetTimeoutId = null;
            }

            resetDisabled.value = true;
            resetErrorText.value = "";

            const resetResult = await app.resetCrossover();

            if (!resetResult.successful) {
                resetErrorText.value = resetResult.message;
                resetClicked.value = false;
                resetDisabled.value = false;
            }
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h5", _hoisted_2, [
        _cache[0] || (_cache[0] = _createTextVNode("Status: ")),
        _createElementVNode("span", {
          class: _normalizeClass({ flash: shouldHighlightRetirementStatus.value })
        }, _toDisplayString(isInRetirementText.value), 3)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (isRetired.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " You have told us that you have started taking cash or pension from your pension pots or you are over the age where you are entitled to your state pension. Guiide will always calculate your plan from the next month. "))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, " You are planning for retirement. You can change your retirement date if you wish to consider different scenarios. "))
      ]),
      (isRetired.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("p", null, " Use the 'Reset' button if you would like to change your account so Guiide considers you to be pre-retirement. This will let you adjust your retirement date again. Your retirement date will be set to next month, but you can change it to any future date. ", -1)),
            _createElementVNode("p", _hoisted_7, _toDisplayString(resetErrorText.value), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn me-md-2", buttonAction.value]),
                  "aria-label": "Reset",
                  disabled: resetDisabled.value,
                  onClick: handleReset
                }, _toDisplayString(buttonText.value), 11, _hoisted_10)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})